import { render } from "./ColorSelectImage.vue?vue&type=template&id=9d9ae220"
import script from "./ColorSelectImage.vue?vue&type=script&lang=js"
export * from "./ColorSelectImage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\sonic\\renault\\new_resources\\renault_configurator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__